export default ({ fill }) => (
  /**
   * Ícone utilizado para alinhamento do
   * rótulo ao da feição
   */
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.17318 17.2844L9.17318 13.1177L13.3398 13.1177L13.3398 10.6177L9.17318 10.6177L9.17318 7.28437L15.8398 7.28437L15.8398 4.78437L9.17318 4.78437L9.17318 0.484375L7.50651 0.484375L7.50651 4.78437L0.839844 4.78437L0.839843 7.28437L7.50651 7.28437L7.50651 10.6177L3.33984 10.6177L3.33984 13.1177L7.50651 13.1177L7.50651 17.2844L9.17318 17.2844Z"
      fill={fill || '#797E82'}
    />
  </svg>
);
